import { render, staticRenderFns } from "./TabComplementaInformacion.vue?vue&type=template&id=0af6197a&scoped=true"
import script from "./TabComplementaInformacion.vue?vue&type=script&lang=js"
export * from "./TabComplementaInformacion.vue?vue&type=script&lang=js"
import style0 from "./TabComplementaInformacion.vue?vue&type=style&index=0&id=0af6197a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af6197a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0af6197a')) {
      api.createRecord('0af6197a', component.options)
    } else {
      api.reload('0af6197a', component.options)
    }
    module.hot.accept("./TabComplementaInformacion.vue?vue&type=template&id=0af6197a&scoped=true", function () {
      api.rerender('0af6197a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/constitucionsociedades/TabComplementaInformacion.vue"
export default component.exports